/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import { Form, Button, Modal, Select } from 'antd';
import { useTranslation, withTranslation } from 'react-i18next';
import VppCredentials from './components/VppCredentials';
import DeviceProperties from './components/DeviceProperties';
import axios from 'axios';
import { handleApiError } from '../../../../../../../../services/utils/errorHandler';
import ConfigContext from '../../../../../../../../components/ConfigContext';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};

const ExternalDevicesModal = props => {
  const { config } = useContext(ConfigContext);
  const [isDeviceEditModalVisible, setDeviceEditModalVisible] = useState(false);
  const [selectedAttribute, setSelectedAttribute] = useState('vppCredentials');
  const { t } = useTranslation();
  const [vppData, setVppData] = useState(null);

  const openDeviceEditModal = () => {
    setDeviceEditModalVisible(true);
    getIosUserData(props.user);
  };

  const getIosUserData = () => {
    let apiURL =
      window.location.origin +
      config.serverConfig.invoker.uri +
      config.serverConfig.invoker.store +
      '/vpp/user?';

    let extraParams = {
      emmUsername: props.user,
    };

    const encodedExtraParams = Object.keys(extraParams)
      .map(key => key + '=' + extraParams[key])
      .join('&');

    axios
      .get(apiURL + encodedExtraParams)
      .then(res => {
        let vppDataObj = {};
        let data = res.data.data;
        if (!res.data.hasOwnProperty('data')) {
          vppDataObj.clientUserId = '';
          vppDataObj.email = '';
          vppDataObj.managedId = '';
          vppDataObj.tmpPassword = '';
        } else {
          vppDataObj.clientUserId = data.clientUserId;
          vppDataObj.email = data.email;
          vppDataObj.managedId = data.managedId;
          vppDataObj.tmpPassword = data.tmpPassword;
          vppDataObj.inviteCode = data.inviteCode;
          vppDataObj.status = data.status;
          vppDataObj.createdTime = data.createdTime;
        }
        setVppData(vppDataObj);
      })
      .catch(error => {
        handleApiError(error, t('api_getVppCredentialsError'), t);
      });
  };

  const onCancelHandler = () => {
    setDeviceEditModalVisible(false);
  };

  const handlePropertyChange = value => {
    setSelectedAttribute(value);
  };

  return (
    <div>
      <div>
        <Button type="link" size={'small'} onClick={openDeviceEditModal}>
          {t('label_userAttributes')}
        </Button>
      </div>
      <div>
        <Modal
          title={t('title_externalDeviceAttributes')}
          width="40%"
          open={isDeviceEditModalVisible}
          onCancel={onCancelHandler}
          maskClosable={false}
          footer={null}
        >
          <div style={{ alignItems: 'center' }}>
            <Form {...formItemLayout} name="deviceAttributes">
              <Form.Item
                name="selectDeviceUserAttribute"
                label={t('label_deviceAttribute')}
              >
                <Select
                  onChange={event => handlePropertyChange(event)}
                  defaultValue={'vppCredentials'}
                >
                  <Select.Option key="vppCredentials" value="vppCredentials">
                    {t('label_vppCredentials')}
                  </Select.Option>
                  <Select.Option
                    key="deviceProperties"
                    value="deviceProperties"
                  >
                    {t('label_deviceProperties')}
                  </Select.Option>
                </Select>
              </Form.Item>
            </Form>
            {selectedAttribute === 'vppCredentials' ? (
              <VppCredentials
                user={props.user}
                callback={onCancelHandler}
                userObj={props.userObj}
                getIosUserData={getIosUserData}
                vppData={vppData}
              />
            ) : (
              <DeviceProperties user={props.user} callback={onCancelHandler} />
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default withTranslation()(ExternalDevicesModal);
